import { axiosInstance } from "../index";
import config from "../config";
import { getHeaders } from './helpers';

const { apiUrl } = config;

export const listCommodityCodes = async () => {
    const result = await axiosInstance
        .get(
            `${apiUrl}/commoditystore/all`,
            { headers: getHeaders() }
        )

    return result.data;
};

export const createCommodityCode = async (value) => {
    const result = await axiosInstance
        .post(
            `${apiUrl}/commoditystore/go`,
            {
                meta: {},
                data: value
            },
            { headers: getHeaders() }
        );

    return result.data;
};

export const deleteCommodityCode = async (creationTime) => {
    const result = await axiosInstance.delete(
        `${apiUrl}/commoditystore/go`,
        {
            data: {
                meta: {
                    creationTime
                }
            },
            headers: getHeaders()
        },
    )

    return result.data
};

export const updateCommodityCode = async (creationTime, data) => {
    const payload = {
        meta: { creationTime, },
        data
    };

    const result = await axiosInstance.put(
        `${apiUrl}/commoditystore/go`,
        payload,
        { headers: getHeaders() }
    );

    return result.data;
}